import { createContext } from "react";
import type { LoaderType } from "./loading.service";

interface LoadingContextType {
  isLoading: boolean;
  loaderType: LoaderType;
  inlineLoadingElement: string | null;
  message?: string;
  subtitle?: string;
  setLoading: (
    loading: boolean,
    loaderType?: LoaderType,
    elementId?: string,
    message?: string,
    subtitle?: string
  ) => void;
}

export const LoadingContext = createContext<LoadingContextType | undefined>(undefined);
